import {
    DialogActions,
    DialogContent,
    DialogTitle,
    Dialog as RawDialog,
    styled,
} from '@mui/material'
import Button from 'components/Control/Button'
import {useI18n} from 'store/Store'

const Dialog = ({
    fullWidth,
    maxWidth,
    handleClose,
    handleSave,
    children,
    open,
    title,
    saveButtonText,
    cancelButtonText,
    showCancel = true,
    showSave = true,
    isValid = true,
    closeOnSave = true,
    onCancel,
}) => {
    const {i18n} = useI18n()

    const onSave = () => {
        handleSave()
        if (closeOnSave) {
            handleClose()
        }
    }

    return (
        <RawDialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
            style={{direction: 'rtl'}}>
            <Title>{title}</Title>
            <DialogContent>{children}</DialogContent>
            <Actions>
                {showCancel && (
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={onCancel}>
                        {cancelButtonText ?? i18n.t('form.cancel')}
                    </Button>
                )}
                {showSave && (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onSave}
                        disabled={!isValid}>
                        {saveButtonText ?? i18n.t('form.confirm')}
                    </Button>
                )}
            </Actions>
        </RawDialog>
    )
}

export default Dialog

const Actions = styled(DialogActions)`
    display: flex;
    margin: 12px;
    justify-content: flex-end;
    gap: 12px;
`

const Title = styled(DialogTitle)`
    font-size: 24px;
    font-weight: bold;
    margin-inline: 48px;
`
